import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';
// Core APIs come from @sentry/browser (see shared/services/sentry-monitor.service.ts).
import { linkedErrorsIntegration } from '@sentry/browser';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import packageJson from '../package.json';

if (environment.production) {
  enableProdMode();
}

// Init only when a DSN is set; otherwise the SDK is a no-op and sends nothing.
if (environment.sentry?.dsn) {
  Sentry.init({
    dsn: environment.sentry.dsn,
    environment: environment.sentry.environment,
    // The app version (bumped by `lerna version` on deploy, also shown in the footer): Sentry tells in which release
    // a failure first appeared or came back.
    release: `venue-workspace@${packageJson.version}`,
    // Manual capture only: disables all automatic error/rejection/session/tracing capture.
    defaultIntegrations: false,
    // Captures nothing by itself: shows a reported error's `cause` as a linked exception with its own stack trace.
    integrations: [linkedErrorsIntegration()],
    // All off, explicitly: once `dataCollection` is given, every field left out defaults to on (Sentry v10). Nothing
    // reads them today (no default integrations), but an integration added later would send them without anyone
    // deciding it. What a failed request sends is decided by `describeApiRequest`.
    dataCollection: {
      userInfo: false,
      cookies: false,
      httpHeaders: { request: false, response: false },
      httpBodies: [],
      queryParams: false,
    },
  });
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
